import { AppRouteProps } from "@bsm/component";
import InvoiceListViewerSignatoriesContainer from "./container/InvoiceListViewerSignatoriesContainer";
import { SignatoryCreateRoutes } from "./views/create/SignatoryCreateRoutes";
import { SignatoryDetailsRoutes } from "./views/details/SignatoryDetailsRoutes";

export const InvoiceListViewerSignatoriesRoutes: Array<AppRouteProps> = [
    {
        path: "signatories",
        element: <InvoiceListViewerSignatoriesContainer />,
        children: [
            ...SignatoryCreateRoutes,
            ...SignatoryDetailsRoutes
        ]
    },
];